import React from 'react';

import { withCommon, ForgotPasswordForm, SimpleForgotPasswordForm } from '../../components';


const ForgotPassword = withCommon({
    store: ({ store }) => ({
        viewSize: store.site.status.viewSize,
        simpleSignup: store.site.simpleSignup,
    }),
    isTrans: true,
})(({ trans, viewSize, simpleSignup }) => {
    return (
        <div
            className={`ll-page forgot-password${
                viewSize === 'mobile' ? '--mobile' : '--tablet'
            }`}
        >
            <p className="forgot-password__header">{trans('Fill the form please')}</p>
            {simpleSignup ? <SimpleForgotPasswordForm /> : <ForgotPasswordForm />}
        </div>
    );
});

export default ForgotPassword;
